<div class="mt-5 mb-5 container" *ngIf="selectedVariables && selectedVariables.length>0">

  <section class="table-container mat-elevation-z8" tabindex="0">
    <table mat-table [dataSource]="selectedVariables">

      <ng-container matColumnDef="station" sticky>
        <th mat-header-cell *matHeaderCellDef> Station</th>
        <td mat-cell *matCellDef="let element"> {{ element.station }}</td>
      </ng-container>

      <ng-container matColumnDef="collectionName" sticky>
        <th mat-header-cell *matHeaderCellDef> Collection</th>
        <td mat-cell *matCellDef="let element"> {{ element.collectionPublicName ? element.collectionPublicName : element.collectionName }}</td>
      </ng-container>

      <ng-container matColumnDef="column" sticky>
        <th mat-header-cell *matHeaderCellDef> Column</th>
        <!--
          #23: display only. `element.column` stays the technical storage/query/request key;
          a resolver miss returns it unchanged, so rows stored before the key/label split —
          whose `column` already holds a public title — still render correctly.
        -->
        <td mat-cell *matCellDef="let element"> {{ element.column | variableDisplayName: publicNamesMap }}</td>
      </ng-container>

      <ng-container matColumnDef="fromDate">
        <th mat-header-cell *matHeaderCellDef> From Date</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <mat-form-field>
            <mat-label>Select a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker" [min]="availableDateMin" [max]="availableDateMax">
              <input matStartDate placeholder="Start date" [value]="element.fromDate" (dateChange)="onStartDateChange($event.value, element, i)">
              <input matEndDate placeholder="End date" [value]="element.toDate" (dateChange)="onEndDateChange($event.value, element, i)">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </td>
      </ng-container>

      <!--<ng-container matColumnDef="toDate">
        <th mat-header-cell *matHeaderCellDef> To Date</th>
        <td mat-cell *matCellDef="let element"> {{element.toDate}} </td>
      </ng-container>-->

      <!--<ng-container matColumnDef="singleDepth">
        <th mat-header-cell *matHeaderCellDef> Single Depth</th>
        <td mat-cell *matCellDef="let element; let i=index">
          <mat-form-field appearance="fill">
            <input matInput type="number" [(ngModel)]="element.singleDepth" [disabled]="element.depthMode==='rangeDepth'" name="singleDepth" required (ngModelChange)="onEditVariable(element, i)" min="0">
          </mat-form-field>
        </td>
      </ng-container>-->

      <ng-container matColumnDef="singleDepth">
        <th mat-header-cell *matHeaderCellDef> Single Depth</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <mat-form-field appearance="fill">
            <mat-select [(ngModel)]="element.singleDepth" [disabled]="element.depthMode === 'rangeDepth'" name="singleDepth" (ngModelChange)="onEditVariable(element, i)">
              <mat-option *ngFor="let depth of availableSingleDepths" [value]="depth">
                {{ depth }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="fromDepth">
        <th mat-header-cell *matHeaderCellDef> From Depth</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <mat-form-field appearance="fill">
            <mat-select
              [(ngModel)]="element.fromDepth"
              [disabled]="element.depthMode === 'singleDepth'"
              name="fromDepth"
              (ngModelChange)="onEditVariable(element, i)">
              <mat-option *ngFor="let depth of availableSingleDepths" [value]="depth">
                {{ depth }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="toDepth">
        <th mat-header-cell *matHeaderCellDef> To Depth</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <mat-form-field appearance="fill">
            <mat-select
              [(ngModel)]="element.toDepth"
              [disabled]="element.depthMode === 'singleDepth'"
              name="toDepth"
              (ngModelChange)="onEditVariable(element, i)">
              <mat-option *ngFor="let depth of availableSingleDepths" [value]="depth">
                {{ depth }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="depthAggregation">
        <th mat-header-cell *matHeaderCellDef> Depth Aggregation</th>
        <td mat-cell *matCellDef="let element; let i=index">
          <mat-form-field *ngIf="element.depthAggregation">
            <mat-select class="select text-capitalize" [disabled]="!element.depthAggregation" [(ngModel)]="element.depthAggregation" name="depthAggregation" (ngModelChange)="onEditVariable(element, i)">
              <mat-option *ngFor="let item of depthAggregations" [value]="item" class="text-capitalize">{{ item }}</mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="dataType">
        <th mat-header-cell *matHeaderCellDef> Data Type</th>
        <td mat-cell *matCellDef="let element; let i=index">
          <mat-form-field *ngIf="element.dataType">
            <mat-select class="select text-capitalize" [disabled]="!element.dataType" [(ngModel)]="element.dataType" name="dataType" (ngModelChange)="onEditVariable(element, i)">
              <mat-option *ngFor="let item of dataAggregations" [value]="item" class="text-capitalize">{{ item }}</mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="timeSteps">
        <th mat-header-cell *matHeaderCellDef> Time Steps</th>
        <td mat-cell *matCellDef="let element; let i=index">
          <mat-form-field *ngIf="element.dataType!=='raw'">
            <mat-select class="select text-capitalize" [disabled]="!element.timeSteps" [(ngModel)]="element.timeSteps" name="timeSteps" (ngModelChange)="onEditVariable(element, i)">
              <mat-option *ngFor="let item of timeSteps" [value]="item" class="text-capitalize">{{ item }}</mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="options" stickyEnd>
        <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
        <td mat-cell *matCellDef="let i = index">
          <mat-icon class="pointer" (click)="removeItem(i)">delete</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </section>
</div>
